import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { serviceCardData as Services } from "../../../Data/All_Services_Data/allServices";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState({
    services: false,
    activeSubServiceIndex: null,
  });
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenSubMenu({ services: false, menu: false });
  };

  const toggleSubMenu = (key, index = null) => {
    setOpenSubMenu((prev) => {
      const newState = { ...prev };

      if (key === "services") {
        newState.services = !prev.services;
        newState.activeSubServiceIndex = null; 
      }

      if (key === "subService") {
        newState.activeSubServiceIndex =
          prev.activeSubServiceIndex === index ? null : index;
      }

      return newState;
    });
  };
  

  return (
    <>
      <div className={`th-menu-wrapper ${isMenuOpen ? "th-body-visible" : ""}`}>
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle" onClick={closeMenu}>
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <NavLink to="/" onClick={closeMenu}>
              <img
                src="assets/img/warrgyizmorsch-logo2.png"
                alt="warrgyizmorsch"
                style={{ height: "100px", width: "auto" }}
              />
            </NavLink>
          </div>
          <div className="th-mobile-menu">
            <ul>
              <li>
                <NavLink to="/" onClick={closeMenu}>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/about-us" onClick={closeMenu}>
                  About Us
                </NavLink>
              </li>
              <li
                className={`menu-item-has-children th-item-has-children ${
                  openSubMenu.services ? "th-active" : ""
                }`}
              >
                <NavLink to="#" onClick={() => toggleSubMenu("services")}>
                  Services<span className="th-mean-expand"></span>
                </NavLink>
                <ul
                  className={`sub-menu th-submenu ${
                    openSubMenu.services ? "th-open" : ""
                  }`}
                  style={{ display: openSubMenu.services ? "block" : "none" }}
                >
                  <li>
                    <NavLink to="/services" onClick={closeMenu}>
                      All Services
                    </NavLink>
                  </li>
                  {Services?.map((service, index) => {
                    return service?.children ? (
                      <li
                        key={index}
                        className={`menu-item-has-children th-item-has-children ${
                          openSubMenu.activeSubServiceIndex === index
                            ? "th-active"
                            : ""
                        }`}
                      >
                        <NavLink
                          to="#"
                          onClick={() => toggleSubMenu("subService", index)}
                        >
                          {service.title}
                          {/* <span className="th-mean-expand"></span> */}
                        </NavLink>
                        <ul
                          className={`sub-menu th-submenu ${
                            openSubMenu.activeSubServiceIndex === index
                              ? "th-open"
                              : ""
                          }`}
                          style={{
                            display:
                              openSubMenu.activeSubServiceIndex === index
                                ? "block"
                                : "none",
                          }}
                        >
                          {service?.children?.map((subService, id) => (
                            <li key={id}>
                              <NavLink to={subService.link} onClick={closeMenu}>
                                {subService.name}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ) : (
                      <li key={index}>
                        <NavLink to={service.link} onClick={closeMenu}>
                          {service.title}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              </li>
              <li>
                <NavLink to="/blog" onClick={closeMenu}>
                  Blog
                </NavLink>
              </li>
              <li>
                <a
                  href="https://portfolio.warrgyizmorsch.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="navlink"
                >
                  Portfolio
                </a>
              </li>
              <li>
                <NavLink to="/gallery" onClick={closeMenu}>
                  Gallery
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact-us" onClick={closeMenu}>
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Header for Web  */}
      <header
        className="th-header header-layout4"
        style={{ position: "relative", backgroundColor: "#18336c" }}
      >
        <div className="header-top" style={{ background: "white" }}>
          <div className="container">
            <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
              <div className="col-auto d-none d-lg-block">
                <div className="header-links">
                  <ul>
                    <li>
                      <i className="fas fa-phone"></i>
                      <a href="tel:+442037695831">+44 2037695831</a>
                    </li>
                    <li>
                      <i className="fas fa-phone"></i>
                      <a href="tel:+918693085077">+91 8693085077</a>
                    </li>
                    <li>
                      <i className="fas fa-envelope"></i>
                      <a href="mailto:info@warrgyizmorsch.com">
                        info@warrgyizmorsch.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-auto">
                <div className="header-social">
                  <span className="social-title">Follow Us On : </span>
                  <a
                    href="https://www.facebook.com/share/1E5k3uqY3x/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/warrgyiz-morsch/posts/?feedView=all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/warrgyiz_morsch"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a
                    href="https://twitter.com/warrgyizmorsch"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="14"
                        width="14"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="#737887"
                          d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                        />
                      </svg>
                    </i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sticky-wrapper">
          <div className="menu-area p-0">
            <div className="container th-container5">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <div className="header-logo">
                    <NavLink className="icon-masking" to="/">
                      <img
                        src="assets/img/warrgyizmorsch-logo.png"
                        alt="warrgyizmorsch"
                        style={{
                          height: "50px",
                          width: "auto",
                          background: "none",
                        }}
                      />
                    </NavLink>
                  </div>
                </div>
                <div className="col-auto">
                  <nav className="main-menu style2 d-none d-lg-inline-block">
                    <ul>
                      <li>
                        <NavLink to="/">Home</NavLink>
                      </li>
                      <li>
                        <NavLink to="/about-us">About Us</NavLink>
                      </li>
                      <li className="menu-item-has-children">
                        <NavLink to="/services">Services</NavLink>
                        <ul className="sub-menu">
                          {Services.map((service, index) => {
                            return service?.children ? (
                              <li
                                key={index}
                                className="menu-item-has-children"
                              >
                                <NavLink
                                  to={service.link}
                                  onClick={(e) => e.preventDefault()}
                                  style={{
                                    cursor: "default",
                                  }}
                                >
                                  {service.title}
                                </NavLink>
                                <ul className="sub-menu">
                                  {service.children.map((subService, id) => {
                                    return (
                                      <li key={id}>
                                        <NavLink to={subService.link}>
                                          {subService.name}
                                        </NavLink>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </li>
                            ) : (
                              <li key={index}>
                                <NavLink to={service.link}>
                                  {service.title}
                                </NavLink>
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                      <li>
                        <NavLink to="/blog">Blog</NavLink>
                      </li>
                        <li>
                        <a
                          href="https://portfolio.warrgyizmorsch.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Portfolio
                        </a>
                      </li>

                      <li>
                        <NavLink to="/gallery">Gallery</NavLink>
                      </li>
                     
                    </ul>
                  </nav>
                  <button
                    type="button"
                    className="th-menu-toggle d-block d-lg-none"
                    onClick={toggleMenu}
                  >
                    <i className="far fa-bars"></i>
                  </button>
                </div>
                <div className="col-auto d-none d-lg-inline-block">
                  <div className="header-button">
                    <NavLink
                      to="/contact-us"
                      className="th-btn style6 style-radius"
                      style={{ padding: "10px 20px" }}
                    >
                      Contact Us
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
